<template>
  <div class="heightPage cardIndex">
    <div v-show="show1">
      <cardIndex :BankList="BankList"
                 :ysList="ysList"
                 :processList="processList"
                 @confirmingBank="confirmingBank"
                 @manage="manage"
                 :type="1">
        <template v-slot:steps>
          <el-steps simple
                    style="width: 90%; margin: 0 auto; margin-top: 30px"
                    class="mySteps"
                    :active="7">
            <el-step title="选择银行"
                     icon="">
              <template slot="icon">
                <span>1</span>
              </template>
            </el-step>
            <el-step title="完善信息">
              <template slot="icon">2</template>
            </el-step>
            <el-step title="通知银行">
              <template slot="icon">3</template>
            </el-step>
            <el-step title="银行预约上门">
              <template slot="icon">4</template>
            </el-step>
            <el-step title="依规开立成功">
              <template slot="icon">5</template>
            </el-step>
          </el-steps>
        </template>
      </cardIndex>
    </div>

    <transition name="el-zoom-in-bottom">
      <CardList v-if="show2"
                @noteCard="noteCard" />
    </transition>
    <transition name="el-zoom-in-bottom">
      <personalDescriptionPage v-if="show3"
                               @noteCard="noteCard"
                               :bankInfoList="bankInfoList" />
    </transition>
    <el-dialog title="提示"
               :visible.sync="tipVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="400px"
               center>
      <i class="el-icon-warning"
         style="margin-bottom: 15px">
        确认发送平安银行的开卡通知吗?
        <el-checkbox v-model="checked">修改</el-checkbox></i>
      <el-form ref="form"
               :model="form"
               :inline="true"
               :rules="rules"
               label-width="auto"
               v-enterToNext="true"
               v-if="checked == true">
        <el-col :span="24">
          <el-form-item label="请选择银行"
                        prop="posState">
            <el-select filterable
                       v-model="form.state"
                       clearable
                       style="width: 100%"
                       placeholder="请选择银行">
              <el-option v-for="item in talentList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="
            () => {
              resetForm();
              selectVisible = false;
            }
          ">关 闭</el-button>
        <el-button size="small "
                   type="primary"
                   :loading="submitLoading"
                   @click="confirm('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import CardList from "./CardList";
import cardIndex from "../../components/cardIndex.vue";

import { verifyPermissionMinix } from "@/utils/mixin";
import personalDescriptionPage from "./personalDescriptionPage";

export default {
  components: {
    CardList,
    cardIndex,
    personalDescriptionPage,
  },
  mixins: [verifyPermissionMinix],
  data () {
    return {
      operation: "",
      addCustomerDrawerShow: false,
      drawerTitle: "",
      noticeDialogVisible: false,
      fileVisible: false,
      selectVisible: false,
      form: {},
      submitLoading: false,
      rules: {},
      talentList: [],
      tipVisible: false,
      checked: false,
      checkList: {},
      checked1: false,
      checked2: false,
      checked3: false,
      show1: true,
      show2: false,
      show3: false,
      bankInfoList: [],
      BankList: [],
      CompanyAutoIntId: "",
      userAutoIntId: "",
      loading: false,
      processList: [
        { num: "01", content: "选择银行" },
        { num: "02", content: "选择人员" },
        { num: "03", content: "扫码办卡或发送通知" },
        { num: "04", content: "点击通知内链接" },
        { num: "05", content: "完成办卡" },
      ],
      ysList: [
        {
          num: 1,
          title: "网申便捷：",
          content: "平台申请预办理，材料、流程清晰。",
        },
        {
          num: 2,
          title: "最优政策：",
          content: "政府倡导，享受国家最优政策。",
        },
      ],
    };
  },
  mounted () {
    this.userAutoIntId = JSON.parse(
      window.localStorage.getItem("userInfo")
    ).autoIntId;
    this.CompanyAutoIntId = JSON.parse(
      window.localStorage.getItem("CompanyDetail")
    ).autoIntId;
    this.getBankList();
  },
  methods: {
    manage () {
      // this.show2 = !this.show2;
      // this.show1 = !this.show1;
      // this.$message.warning("功能暂未开放，更多敬请期待！");
      // return;
      this.$confirm("功能暂未开放，更多敬请期待！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: false,
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$router.push("/home");
        })
        .catch(() => {
          this.$router.push("/home");
        });
    },
    confirmingBank () {
      this.$confirm("功能暂未开放，更多敬请期待！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: false,
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$router.push("/home");
        })
        .catch(() => {
          this.$router.push("/home");
        });
      // if (this.bankInfoList.length <= 0) {
      //   this.$message.error("请选择产品");
      //   return;
      // }
      // this.show1 = !this.show1;
      // this.show3 = !this.show3;
      // this.$router.push(
      //   "/personalDescriptionPage?list=" + JSON.stringify(this.bankInfoList)
      // );
    },
    getBankList () {
      this.loading = true;
      this.$api.manage.PensionAccountsBusiness().then((res) => {
        this.loading = false;
        if (res.error === false) {
          this.BankList = res.data;
          this.BankList.forEach((item) => {
            this.$set(item, "check", false);
          });

        } else {
          this.$message.error(res.msg);
        }
      });
    },
    confirm () {
      this.show2 = !this.show2;
      this.show1 = !this.show1;
    },
    noteCard () {
      this.show2 = !this.show2;
      this.show1 = !this.show1;
    },
    myselect (item) {
      if (item.check == true) {
        this.$set(item, "check", !item.check);
        this.bankInfoList = [];
      } else {
        this.BankList.forEach((item) => {
          item.check = false;
        });
        this.$set(item, "check", !item.check);
        this.bankInfoList = [];
      }
      this.bankInfoList = [];
      this.BankList.forEach((item) => {
        if (item.check) {
          this.bankInfoList.push({
            bankId: item.bankId,
            bankName: item.bankName,
            autoIntId: item.autoIntId,
            userAutoIntId: this.userAutoIntId,
            bankBusinessId: item.id,
            bankAutoIntId: item.bankAutoIntId,
            CompanyAutoIntId: this.CompanyAutoIntId,
          });
        }
      });
      this.$forceUpdate();
    },
    addbank (item) {
      if (item.check == true) {
        this.$set(item, "check", !item.check);
        this.bankInfoList = [];
      } else {
        this.BankList.forEach((item) => {
          item.check = false;
        });
        this.$set(item, "check", !item.check);
        this.bankInfoList = [];
      }
      this.BankList.forEach((item) => {
        if (item.check) {
          this.bankInfoList.push({
            bankId: item.bankId,
            bankName: item.bankName,
            autoIntId: item.autoIntId,
            userAutoIntId: this.userAutoIntId,
            bankBusinessId: item.id,
            bankAutoIntId: item.bankAutoIntId,
            CompanyAutoIntId: this.CompanyAutoIntId,
          });
        }
      });
    },
    singleNot () {
      this.fileVisible = true;
      // this.importVisible = true;
    },
    addPersonnel () {
      if (this.bankInfoList.length <= 0) {
        this.$message.error("请选择银行");
        return;
      }
      this.operation = "add";
      this.addCustomerDrawerShow = true;
      this.drawerTitle = "新增人员开卡";
    },
    resetForm () { },
    notifyCard () {
      if (this.bankInfoList.length <= 0) {
        this.$message.error("请选择银行");
        return;
      }
      this.noticeDialogVisible = true;
    },
  },
};
</script>
<style>
.checkbox {
  zoom: 200%;
}
</style>
<style lang="less" scoped>
.tip {
  text-align: center;
  margin-top: 20px;
  color: #e6a23c;
}
.title {
  font-size: 30px;
  text-align: center;
  color: #333333;
  font-weight: normal;
  text-align: center;
}
.btnContainer {
  width: 100%;
  text-align: center;
  position: relative;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>